import type { AssistantChatListItem, AssistantChatRecord } from './types'
import { getChatLastActivityTimestamp, getTimestampSortValue } from 'tripPlanner/utils/chatTimestamps'
import { buildRecentAiChatItem } from 'tripPlanner/utils/recentAiChatItem'

export function sortAssistantChatRecordsByLastActivity(chats: Array<AssistantChatRecord>): Array<AssistantChatRecord> {
  return chats.toSorted((a, b) => {
    return getTimestampSortValue(getChatLastActivityTimestamp(b)) - getTimestampSortValue(getChatLastActivityTimestamp(a))
  })
}

export function mapAssistantChatListItem(chat: AssistantChatRecord): AssistantChatListItem {
  const recentChatItem = buildRecentAiChatItem(chat)

  return {
    id: recentChatItem.id,
    title: recentChatItem.title,
    preview: recentChatItem.subtitle,
    description: recentChatItem.description,
    updatedAt: recentChatItem.updatedAt,
  }
}
